// TSS vite/04 — public envelope helper (decisión 0052 / Q-108).
//
// Composed public reads (/recipients, /donors, /donors/:id, /calves, /stats)
// come WRAPPED by the backend:
//   { schema_version, view, generated_at, data: {…}, available_modules }
// Identity reads (/me, /permissions, /auth/*) are NOT wrapped.
//
// Tolerant reader: returns the inner `data` when the body looks enveloped,
// otherwise the body itself (defensive if a surface is ever served flat).
// Null-safe — always returns an object, so callers can `?.` freely without a
// guard. The front pins schema_version (additive-only), so unknown fields in
// `data` are ignored, not read.

const ENVELOPE_MARKERS = ['schema_version', 'available_modules', 'generated_at'];

function isEnvelope(body) {
    if (!body || typeof body !== 'object' || body.data == null || typeof body.data !== 'object') {
        return false;
    }
    // A marker key at the top level, or the payload the envelope's `data` would
    // carry (a list) sitting under `data` rather than at the root.
    return ENVELOPE_MARKERS.some((key) => key in body) || Array.isArray(body.data.items);
}

// The `data` payload of a composed read (items+pagination, or stat blocks).
export function envelopeData(body) {
    if (isEnvelope(body)) return body.data;
    return body && typeof body === 'object' ? body : {};
}

// available_modules[] — which modules the client MAY see per its roles_with_data
// (MODULE_ROLE). Empty array when absent. Distinguishes "empty by lack of data"
// (module present, count 0) from "N/A for your role" (module absent).
export function envelopeModules(body) {
    return Array.isArray(body?.available_modules) ? body.available_modules : [];
}
